import { render, staticRenderFns } from "./CustormerOrder.vue?vue&type=template&id=228748e8"
import script from "./CustormerOrder.vue?vue&type=script&lang=js"
export * from "./CustormerOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports